import { useEffect, useState } from 'react'

const UseResize = () => {
  const [desktop, setdesktop] = useState(false)
  const [header, setheader] = useState(false)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setdesktop(true);
      } else {
        setdesktop(false);
      }
    };
    const handleHResize = () => {
      if (window.scrollY >= 30) {
        setheader(true);
      } else {
        setheader(false);
      }
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener("scroll", handleHResize);
    handleResize();
    handleHResize();
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleHResize);
    };
  }, []);
  return (
   {desktop,
   setdesktop,
   setheader,
   header}
  )
}

export default UseResize